import { Component, OnInit } from "@angular/core";
import { DataService_ReasonMaintenance } from "./shared/data.service";
import { UserService } from "../../../shared";
import { DialogService } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { MsAddVisitorReasonComponent } from "./ms-add-visitor-reason/ms-add-visitor-reason.component";
import { MsEditVisitorReasonComponent } from "./ms-edit-visitor-reason/ms-edit-visitor-reason.component";

@Component({
	selector: "app-multi-station-reason-maintenance",
	templateUrl: "./multi-station-reason-maintenance.component.html",
	styleUrls: ["./multi-station-reason-maintenance.component.css"],
})
export class MultiStationReasonMaintenanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private visitorService: DataService_ReasonMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadVisitorReason();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	Processing: any = false;
	errorMessage: any = "";

	SelectedVisitorReason: any;
	lstVisitorReason: any = [];

	lstDefinedByDesc: any = [];
	lstActiveDesc: any = [];
	lstCanEditDesc: any = [];

	ToggleText: string = "Deactivate Reason";

	MaxActive: number = 0;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadVisitorReason() {
		this.loading = true;

		var result = this.visitorService.VisitorReasonPreferenceInfoSelect();
		result.subscribe(
			(response: any) => {
				this.MaxActive = response.MaxActive;
				this.lstVisitorReason = response.lstInfo;

				//Load Data Filter Lists
				this.lstDefinedByDesc = Array.from(new Set(this.lstVisitorReason.map((item: any) => item.DefinedByDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstVisitorReason.map((item: any) => item.ActiveDesc))).sort();
				this.lstCanEditDesc = Array.from(new Set(this.lstVisitorReason.map((item: any) => item.CanEditDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadVisitorReason();
	}

	onAdd() {
		this.errorMessage = "";

		if (this.CountActive() >= this.MaxActive) {
			this.errorMessage = "You can only have " + this.MaxActive + " reasons active at a time. Please deactivate a reason before you add new ones";
			return;
		}

		var ref = this.dialogService.open(MsAddVisitorReasonComponent, {
			header: "Add Reason",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadVisitorReason();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedVisitorReason == undefined) {
			this.errorMessage = "Select a Reason";
			return;
		}
		if (this.SelectedVisitorReason.DefinedByID <= 2) {
			this.errorMessage = "System-Defined Reasons cannot be edited, only deactivated";
			return;
		}
		if (this.SelectedVisitorReason.CanEdit == false) {
			this.errorMessage = "Reasons that have already been used cannot be edited, only deactivated";
			return;
		}

		var ref = this.dialogService.open(MsEditVisitorReasonComponent, {
			header: "Edit Reason",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				VisitorReasonID: this.SelectedVisitorReason.VisitorReasonID,
				VisitorReasonDesc: this.SelectedVisitorReason.VisitorReasonDesc,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadVisitorReason();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedVisitorReason == undefined) {
			this.errorMessage = "Select a Reason";
			return;
		}

		var changeTo = this.SelectedVisitorReason.Active == true ? 0 : 1;

		if (changeTo == 1 && this.CountActive() >= this.MaxActive) {
			this.errorMessage = "You can only have " + this.MaxActive + " reasons active at a time. Please deactivate a reason before you activate new ones";
			return;
		}

		this.Processing = true;

		//Call SP
		var result = this.visitorService.VisitorReasonToggle(this.SelectedVisitorReason.VisitorReasonID, changeTo);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.onRowUnselect(null);
					this.loadVisitorReason();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (changeTo == 1 ? "Activate" : "Deactivate") + " the visitor type: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onDelete() {
		//Error handling
		if (this.SelectedVisitorReason == undefined) {
			this.errorMessage = "Select a Reason";
			return;
		}
		if (this.SelectedVisitorReason.DefinedByID <= 2) {
			this.errorMessage = "System-Defined Reasons cannot be deleted, only deactivated";
			return;
		}
		if (this.SelectedVisitorReason.CanEdit == false) {
			this.errorMessage = "Reasons that have already been used cannot be deleted, only deactivated";
			return;
		}

		this.confirmationService.confirm({
			key: "mainconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: `Are you sure you want to delete the reason: ${this.SelectedVisitorReason.VisitorReasonDesc}?`,
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
		});
	}

	FinishDelete() {
		this.Processing = true;

		var result = this.visitorService.VisitorReasonDelete(this.SelectedVisitorReason.VisitorReasonID);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.onRowUnselect(null);
					this.loadVisitorReason();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the visitor type: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedVisitorReason = val.data;

		this.ToggleText = "Deactivate Reason";
		if (this.SelectedVisitorReason.Active == false) {
			this.ToggleText = "Activate Reason";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedVisitorReason = null;
		this.ToggleText = "Deactivate Reason";
	}
	onRowDblClick(VisitorReason) {
		this.errorMessage = "";

		this.SelectedVisitorReason = VisitorReason;

		this.ToggleText = "Deactivate Reason";
		if (this.SelectedVisitorReason.Active == false) {
			this.ToggleText = "Activate Reason";
		}

		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	CountActive(): number {
		var count = 0;

		for (var z = 0; z < this.lstVisitorReason.length; z++) {
			var next = this.lstVisitorReason[z];

			if (next.Active == true) {
				count++;
			}
		}

		return count;
	}

	////////////////////////////////////////////
}
